import { Product } from "../shared/sdk/types"
import { formatPrice } from "../shared/utils/format"

const price = (language: string, product?: Product, realPrice?: boolean) => {
    if (!product) return

    return product.sku === "LV2START" && !realPrice
        ? formatPrice(
              product.price.current.taxed / (product.configuration.splitted?.parts || 1),
              product.price.currency.name,
              language
          )
        : formatPrice(product.price.current.taxed, product.price.currency.name, language)
}

export { price }
